<template>
  <svg
    v-if="color === 'green'"
    class="svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4464 1.26399C15.3704 1.10281 15.2082 1 15.03 1H0.762119C0.583939 1 0.421778 1.10281 0.345731 1.26399C0.269745 1.42516 0.29356 1.61568 0.406925 1.75317L5.89172 8.40555V14.5397C5.89172 14.6989 5.97403 14.8469 6.1093 14.9308C6.18345 14.9768 6.2676 15 6.35205 15C6.42184 15 6.49187 14.9841 6.55644 14.9521L9.6381 13.4247C9.79468 13.3472 9.89374 13.1876 9.89399 13.0129L9.9 8.40574L15.3851 1.75311C15.4985 1.61568 15.5224 1.4251 15.4464 1.26399ZM9.08478 7.94737C9.01696 8.02961 8.97976 8.13291 8.97964 8.23959L8.97375 12.7265L6.81245 13.7977V8.2402C6.81245 8.13334 6.77532 8.0298 6.70731 7.94737L1.73827 1.92061H14.0538L9.08478 7.94737Z"
      fill="#00d26e"
      stroke="#00d26e"
      stroke-width="0.5"
    />
  </svg>
  <svg
    v-else
    class="svg"
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9562 1.26399C15.8802 1.10281 15.718 1 15.5398 1H1.27188C1.0937 1 0.931544 1.10281 0.855497 1.26399C0.779511 1.42516 0.803325 1.61568 0.91669 1.75317L6.40148 8.40555V14.5397C6.40148 14.6989 6.48379 14.8469 6.61907 14.9308C6.69321 14.9768 6.77736 15 6.86182 15C6.93161 15 7.00164 14.9841 7.06621 14.9521L10.1479 13.4247C10.3044 13.3472 10.4035 13.1876 10.4038 13.0129L10.4098 8.40574L15.8949 1.75311C16.0083 1.61568 16.0322 1.4251 15.9562 1.26399ZM9.59455 7.94737C9.52673 8.02961 9.48953 8.13291 9.48941 8.23959L9.48351 12.7265L7.32221 13.7977V8.2402C7.32221 8.13334 7.28508 8.0298 7.21707 7.94737L2.24804 1.92061H14.5636L9.59455 7.94737Z"
      fill="#7F8B99"
      stroke="#7F8B99"
      stroke-width="0.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconFilter',

  props: {
    color: {
      // класс цвета который красит картинку
      type: String,
      default: 'grey'
    },

    hover: {
      // класс цвета который красит картинку при :hover
      type: String,
      default: ''
    }
  }
};
</script>
